import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AccountDataService } from '../../account-data.service';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import { MaterialModule } from '../../../../modules/material.module';
import { ReauthDialogComponent } from '../reauth-dialog/reauth-dialog.component';

@Component({
  selector: 'app-delete-account-dialog',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './delete-account-dialog.component.html',
  styleUrl: './delete-account-dialog.component.scss',
})
export class DeleteAccountDialogComponent {
  private readonly dialogRef = inject(
    MatDialogRef<DeleteAccountDialogComponent>
  );
  private readonly ac = inject(AccountDataService);
  private readonly router = inject(Router);
  private readonly dialog = inject(MatDialog);

  private onClose(): void {
    this.dialogRef.close();
  }

  /**
   * deletes this user's ProjectZen account by marking account as deleted in backend SQL database and deleting associated account in firebase authentication
   */
  deleteUserAccount(): void {
    const self = this;

    this.ac.markAccountAsDeletedInSQL().subscribe({
      next: (response) => {
        if (environment.debuggingConsoleLogsOn) {
          console.log(response.result);
        }
        this.ac
          .deleteUserAccountInFirebase()
          .then(function () {
            if (environment.debuggingConsoleLogsOn) {
              console.log('Account deleted in firebase');
            }
            self.onClose();
            self.router.navigate(['home']); // and navigate to homepage
          })
          .catch(function (error) {
            console.log(error);
            if (error.code == 'auth/requires-recent-login') {
              self.onClose();
              // display a modal dialog for delete account
              self.dialog.open(ReauthDialogComponent, {
                width: '600px',
              });
            }
          });
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
}
